import { StatCard, VendorCategory } from '../../../models/dashboard.model';

export interface RevenueTrendPoint {
  month: string;
  value: number;
}

export interface VendorsByMdaPoint {
  label: string;
  count: number;
}

export interface PaymentMethodPoint {
  label: string;
  value: number;
  color: string;
}

export interface CategoryFeeSummaryRow {
  category: string;
  contractRange: string;
  registrationFee: number;
  vendors: number;
  revenue: number;
}

export const REPORT_STAT_CARDS: StatCard[] = [
  {
    title: 'Total Revenue',
    value: '₦380,750,850',
    change: '+26.4%',
    changeType: 'positive',
    subtitle: 'vs last period',
  },
  {
    title: 'Active Vendors',
    value: '165',
    change: '+12',
    changeType: 'positive',
    subtitle: 'vs last period',
  },
  {
    title: 'Pending Approvals',
    value: '2',
    change: 'Requires action',
    changeType: 'warning',
    subtitle: '',
  },
  {
    title: 'Avg. Processing Time',
    value: '3.2 Days',
    change: '-0.5 days',
    changeType: 'positive',
    subtitle: 'vs last period',
  },
];

export const REPORT_REVENUE_TREND: RevenueTrendPoint[] = [
  { month: 'Jan', value: 2_800_000 },
  { month: 'Feb', value: 3_100_000 },
  { month: 'Mar', value: 4_400_000 },
  { month: 'Apr', value: 3_900_000 },
  { month: 'May', value: 5_600_000 },
  { month: 'Jun', value: 5_300_000 },
];

export const REPORT_VENDOR_CATEGORIES: VendorCategory[] = [
  { name: 'Category A', count: 35, color: '#16A34A' },
  { name: 'Category B', count: 45, color: '#F59E0B' },
  { name: 'Category C', count: 15, color: '#1D4ED8' },
  { name: 'Category D', count: 5, color: '#0EA5B7' },
];

export const REPORT_VENDORS_BY_MDA: VendorsByMdaPoint[] = [
  { label: 'Education', count: 20 },
  { label: 'Housing', count: 12 },
  { label: 'Health', count: 24 },
  { label: 'Works', count: 30 },
  { label: 'Construction', count: 27 },
];

export const REPORT_PAYMENT_METHODS: PaymentMethodPoint[] = [
  { label: 'Card', value: 46, color: '#22C55E' },
  { label: 'Bank Transfer', value: 54, color: '#1D4ED8' },
];

export const REPORT_CATEGORY_FEE_SUMMARY: CategoryFeeSummaryRow[] = [
  {
    category: 'Category A',
    contractRange: '₦0 - ₦100m',
    registrationFee: 50_000,
    vendors: 23,
    revenue: 70_000,
  },
  {
    category: 'Category B',
    contractRange: '₦100.001M - ₦500M',
    registrationFee: 200_000,
    vendors: 2,
    revenue: 500_000,
  },
  {
    category: 'Category C',
    contractRange: '₦500.001M - ₦1B',
    registrationFee: 500_000,
    vendors: 6,
    revenue: 720_000,
  },
  {
    category: 'Category D',
    contractRange: '₦1.001B - ₦2B',
    registrationFee: 1_000_000,
    vendors: 12,
    revenue: 1_300_000,
  },
  {
    category: 'Category E',
    contractRange: '₦2.001B - ₦5B',
    registrationFee: 2_000_000,
    vendors: 0,
    revenue: 0,
  },
  {
    category: 'Category F',
    contractRange: 'Above ₦5B',
    registrationFee: 5_000_000,
    vendors: 0,
    revenue: 0,
  },
];
